module.exports = __webpack_public_path__ + "static/media/referral-program-hero.d60dfbc0.jpg";